import { render, staticRenderFns } from "./KPage.vue?vue&type=template&id=012b2898&scoped=true&lang=html&"
import script from "./KPage.vue?vue&type=script&lang=ts&"
export * from "./KPage.vue?vue&type=script&lang=ts&"
import style0 from "./KPage.vue?vue&type=style&index=0&id=012b2898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b2898",
  null
  
)

export default component.exports